import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const bookingAPI = {
  // Create a new booking (not used anymore - payment flow used instead)
  createBooking: async (bookingData) => {
    const response = await axios.post(`${API}/bookings`, bookingData);
    return response.data;
  },

  // Get all bookings
  getAllBookings: async (params = {}) => {
    const response = await axios.get(`${API}/bookings`, { params });
    return response.data;
  },

  // Get booking stats
  getBookingStats: async () => {
    const response = await axios.get(`${API}/bookings/stats`);
    return response.data;
  },

  // Get archived bookings
  getArchivedBookings: async () => {
    const response = await axios.get(`${API}/bookings/archived`);
    return response.data;
  },

  // Get single booking
  getBooking: async (id) => {
    const response = await axios.get(`${API}/bookings/${id}`);
    return response.data;
  },

  // Update booking
  updateBooking: async (id, bookingData) => {
    const response = await axios.patch(`${API}/bookings/${id}`, bookingData);
    return response.data;
  },

  // Update booking status
  updateBookingStatus: async (id, status) => {
    const response = await axios.patch(`${API}/bookings/${id}/status`, { status });
    return response.data;
  },

  // Archive booking
  archiveBooking: async (id) => {
    const response = await axios.patch(`${API}/bookings/${id}/archive`);
    return response.data;
  },

  // Unarchive booking
  unarchiveBooking: async (id) => {
    const response = await axios.patch(`${API}/bookings/${id}/unarchive`);
    return response.data;
  },

  // Delete booking
  deleteBooking: async (id) => {
    const response = await axios.delete(`${API}/bookings/${id}`);
    return response.data;
  },

  // Resend confirmation email
  resendConfirmation: async (id) => {
    const response = await axios.post(`${API}/bookings/${id}/resend-confirmation`);
    return response.data;
  },

  // Download PDF
  downloadPDF: async (id) => {
    const response = await axios.get(`${API}/bookings/${id}/pdf`, {
      responseType: 'blob'
    });
    return response.data;
  }
};

export const paymentAPI = {
  // Create checkout session
  createCheckoutSession: async (bookingData) => {
    const originUrl = window.location.origin;
    const response = await axios.post(`${API}/payments/create-checkout-session`, {
      bookingData,
      originUrl
    });
    return response.data;
  },

  // Get checkout status
  getCheckoutStatus: async (sessionId) => {
    const response = await axios.get(`${API}/payments/checkout-status/${sessionId}`);
    return response.data;
  }
};

export const settingsAPI = {
  // Get pricing
  getPricing: async () => {
    const response = await axios.get(`${API}/settings/pricing`);
    return response.data;
  },

  // Update pricing
  updatePricing: async (pricingData) => {
    const response = await axios.put(`${API}/settings/pricing`, pricingData);
    return response.data;
  }
};